import React from 'react';
import PropTypes from 'prop-types';
import QuickLinksFragment from '../../components/QuickLinksFragment';
import SearchRow from '../../components/SearchRow';

const SearchPage = ({ deviceInfo = {}, ...props }) => {
  return (
    <div id="appcenter-main">
      <div id="appcenter-categories">
        <SearchRow {...props} />
      </div>
      {deviceInfo.isDesktop && <QuickLinksFragment />}
    </div>
  );
};

SearchPage.displayName = 'search';

SearchPage.propTypes = {
  fptiClick: PropTypes.func,
  appSearch: PropTypes.object,
  flatPSData: PropTypes.object,
  toolTileProps: PropTypes.object,
  deviceInfo: PropTypes.object
};

export default SearchPage;
